module.exports = __webpack_public_path__ + "img/Dantam Makeover 21.a06c6659.jpg";